import * as React from 'react'
import {
  faPen,
  faEuroSign,
  faEdit,
  IconDefinition,
  faGavel
} from '@fortawesome/pro-light-svg-icons'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'

import { PublishedApp } from '../../../../domain'
import { t } from '../../../../i18n'

import {
  appStepModel,
  decisionStepModel,
  preReportStepModel,
  paymentStepModel,
  postReportStepModel,
  recoveryStepModel,
  StepModel
} from './model'
import { Step } from './step'

interface Props {
  app: PublishedApp
}

export const ProcessSteps: React.FC<Props> = (p) => {
  return (
    <div className="stepper is-x-large" data-qa="application-process">
      {renderStep(appStepModel(p.app), 'APPLICATION', faPen)}
      {renderStep(decisionStepModel(p.app), 'DECISION', faGavel)}
      {renderStep(preReportStepModel(p.app), 'PRE_REPORT', faEdit)}
      {renderStep(paymentStepModel(p.app), 'PAYMENT', faEuroSign)}
      {renderStep(postReportStepModel(p.app), 'POST_REPORT', faEdit)}
      {renderStep(recoveryStepModel(p.app), 'RECOVERY', faEuroSign)}
    </div>
  )
}

type StepName =
  | 'APPLICATION'
  | 'DECISION'
  | 'PRE_REPORT'
  | 'PAYMENT'
  | 'POST_REPORT'
  | 'RECOVERY'

const renderStep = (model: StepModel, name: StepName, icon: IconDefinition) =>
  pipe(
    model,
    O.map((x) => (
      <Step
        key={name}
        dataQa={name}
        title={t(['views', 'preview', 'processSteps', name, 'title'])}
        icon={icon}
        label={x.label}
        status={x.status}
      />
    )),
    O.toNullable
  )
